/* eslint-disable complexity */
import { BookWidgetAem } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsConfig } from '../../models/core-apis/catalog-api.interfaces';
import { DefaultLookupFieldsConfig } from '../../models/core-apis/default-lookup.interfaces';
import { LoginDashboardFieldsConfig } from '../../models/login-dashboard.interfaces';
import { FeatureFlags } from '../../models/states/feature-flags-state.interfaces';
import { stringToBoolean } from '../utils/utils.adapter';

export const prepareBookWidgetFieldsMasterConfig = (
  featureFlags: FeatureFlags | null,
  defaultsLookupFieldsConfig: DefaultLookupFieldsConfig | null,
  catalogApiFieldsConfig: CatalogApiFieldsConfig | null,
  loginDashboardFieldsConfig: LoginDashboardFieldsConfig | null,
  bookWidgetAem: BookWidgetAem | null
): BookWidgetFieldsMasterConfig => {
  return {
    tripTypesField: {
      disable:
        defaultsLookupFieldsConfig?.disableTripType ||
        catalogApiFieldsConfig?.disableTripType
    },
    passengerField: {
      disable:
        loginDashboardFieldsConfig?.restrictPaxToOne ||
        defaultsLookupFieldsConfig?.disablePaxDropDown ||
        catalogApiFieldsConfig?.disablePaxDropDown
    },
    shopMilesField: {
      disable:
        loginDashboardFieldsConfig?.disableMiles ||
        defaultsLookupFieldsConfig?.disableShopMiles ||
        catalogApiFieldsConfig?.disableShopMiles,
      hide: featureFlags?.hideShopMiles
    },
    refundableFareField: {
      disable:
        loginDashboardFieldsConfig?.bookOnlyRefundable ||
        defaultsLookupFieldsConfig?.disableRefundableFares ||
        catalogApiFieldsConfig?.disableRefundableFares,
      hide: featureFlags?.hideRefundableFares
    },
    flexDatesField: {
      disable:
        defaultsLookupFieldsConfig?.disableFlexibleDates ||
        catalogApiFieldsConfig?.disableFlexibleDates,
      hide: featureFlags?.hideFlexibleDates
    },
    basicFaresField: {
      hide: getBasicFareFieldHideValue(
        catalogApiFieldsConfig,
        defaultsLookupFieldsConfig,
        bookWidgetAem
      )
    },
    flexAirportsField: {
      disable:
        defaultsLookupFieldsConfig?.disableNearbyAirport ||
        catalogApiFieldsConfig?.disableNearbyAirport,
      hide: featureFlags?.hideNearbyAirport
    },
    bestFareOptionsField: {
      disable:
        defaultsLookupFieldsConfig?.disableBestFares ||
        catalogApiFieldsConfig?.disableBestFares,
      hide: featureFlags?.hideBestFares
    },
    meetingEventCodeField: {
      disable:
        defaultsLookupFieldsConfig?.disableMeetingCode ||
        catalogApiFieldsConfig?.disableMeetingCode,
      hide: featureFlags?.hideMeetingCode
    },
    edocsLink: {
      disable:
        defaultsLookupFieldsConfig?.disableEdocLink ||
        catalogApiFieldsConfig?.disableEdocLink,
      hide: featureFlags?.hideEdocLink
    }
  };
};

const getBasicFareFieldHideValue = (
  catalogApiFieldsConfig: CatalogApiFieldsConfig | null,
  defaultsLookupFieldsConfig: DefaultLookupFieldsConfig | null,
  bookWidgetAem: BookWidgetAem | null
) => {
  let featureFlagHideValue = !stringToBoolean(
    bookWidgetAem?.defaultValues?.showBasicFares
  );

  if (catalogApiFieldsConfig) {
    featureFlagHideValue =
      featureFlagHideValue || !catalogApiFieldsConfig.showBasicFares;
  }

  return featureFlagHideValue || defaultsLookupFieldsConfig?.hideBasicFares;
};
